<template>
    <div class="block-content overflow-hidden pt-0">
        <input type="hidden" name="slug" :value="slug" class="form-control" />
        <input type="hidden" name="name" :value="name" class="form-control" />
        <input type="hidden" name="image" :value="image" class="form-control" />
        <input type="hidden" name="faqs" :value="JSON.stringify(faqs)" />
        <input type="hidden" name="description" :value="description" class="form-control" />

        <div ref="questions">
            <div id="question-component" class="question-component">
                <!-- :prestations="prestations"
                    :tagcategories="tagcategories" -->
                <survey-question
                    @delete-event="deleteHandler"
                    @up-event="upHandler"
                    @low-event="lowHandler"
                    v-for="(question, index) in questions"
                    :key="index"
                    :question="question"
                    :identifier="question.id"
                    :indexQuestion="index"
                    :lengthQuestions="questions.length"
                    :boundsEnabled="boundsEnabled"
                ></survey-question>

                <div class="row mb-1">
                    <div
                        id="addQuestion"
                        class="add_new_question d-flex container justify-content-center mb-5 rounded-12 pt-2 height_btn_page btn-dark fw-semibold mt-4 w-25 btn-add-survey"
                        @click="addQuestion"
                    >
                        {{ $t('common.add_question') }}
                    </div>
                </div>

                <div class="container rounded-16 pt-4 pb-0 my-3" style="border: 1px solid rgb(248, 249, 249)">
                    <div class="block-header py-2">
                        <div class="block-content block-content-full rounded-8 border-left-pink mb-4 overflow-hidden">
                            <div class="row justify-content-center py-1 not-option">
                                <div class="col-11">
                                    <div class="block-header">
                                        <h3 class="text-center block-title fs-5 fw-semibold text-light-blue mb-3">
                                            {{ $t('common.faq') }}
                                        </h3>
                                    </div>

                                    <div class="row justify-content-center py-3">
                                        <div class="col-12 mb-4 position-relative">
                                            <span
                                                id="aiButton"
                                                class="btn btn-primary-ai"
                                                @click="showTooltip"
                                                :disabled="isLoading"
                                            >
                                                <img class="ai_image" src="/media/svg/ai-white.png" alt="Ai_logo" />
                                                <span id="button-text">{{ buttonReqAiText }}</span>
                                                <span
                                                    class="spinner-border spinner-border-sm text-primary"
                                                    role="status"
                                                    aria-hidden="true"
                                                    v-if="isLoading"
                                                ></span>
                                            </span>

                                            <div v-if="showAiPrompt" class="tooltip pt-3" @mouseleave="hideTooltip">
                                                <span class="mb-2 p-1 float-end btn_close_foodMD" @click="hideTooltip">
                                                    <i class="fa fa-times"></i>
                                                </span>

                                                <textarea
                                                    class="form-control"
                                                    rows="4"
                                                    v-model="promptFaq"
                                                    :placeholder="$t('survey.ai_placeholder')"
                                                >
                                                </textarea>

                                                <button
                                                    class="btn btn-primary mt-2"
                                                    type="button"
                                                    :disabled="isLoading || !promptFaq != ''"
                                                    @click="handleButtonClick"
                                                >
                                                    {{ buttonSendText }}
                                                    <span
                                                        class="spinner-border spinner-border-sm text-primary"
                                                        role="status"
                                                        aria-hidden="true"
                                                        v-if="isLoading"
                                                    ></span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <faq-component
                                        :faqs="faqs"
                                        @add-faq="addFAQ"
                                        @remove-faq="removeFAQ"
                                        @move-up="moveUp"
                                        @move-down="moveDown"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="container rounded-16 pt-4 pb-0 my-3" style="border: 1px solid rgb(248, 249, 249)">
                    <div class="block-header py-2">
                        <div class="block-content block-content-full rounded-8 border-left-pink mb-4 overflow-hidden">
                            <div class="row justify-content-center py-1 not-option">
                                <div class="col-11">
                                    <div class="block-header">
                                        <h3 class="text-center block-title fs-5 fw-semibold text-light-blue mb-4">
                                            {{ $t('survey.description') }}
                                        </h3>
                                    </div>
                                    <survey-description-component v-model="description" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="container rounded-16 pt-4 pb-0 my-3" style="border: 1px solid rgb(248, 249, 249)">
                    <div class="block-header py-2">
                        <div class="block-content block-content-full rounded-8 border-left-pink mb-4">
                            <div class="d-flex container justify-content-center text-center">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="block-header">
                                            <h3 class="text-center block-title fs-5 fw-semibold text-light-blue mb-4 pb-2">
                                                {{ $t('survey.image') }}
                                            </h3>
                                        </div>
                                        <div class="form-group" @click="triggerFileUpload">
                                            <div class="form-control overflow-hidden text-center new-image desg_new_img">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="29"
                                                    height="24"
                                                    viewBox="0 0 29 24"
                                                    fill="none"
                                                >
                                                    <path
                                                        d="M7.33321 19.0016C5.66958 19.0016 4.07409 18.3694 2.89772 17.2442C1.72136 16.119 1.06049 14.5929 1.06049 13.0016C1.06049 11.4103 1.72136 9.88414 2.89772 8.75892C4.07409 7.6337 5.66958 7.00156 7.33321 7.00156C7.72613 5.25113 8.87556 3.71287 10.5287 2.72518C11.3472 2.23613 12.2647 1.89696 13.2289 1.72705C14.1931 1.55713 15.185 1.5598 16.148 1.7349C17.1111 1.90999 18.0263 2.25409 18.8416 2.74754C19.6569 3.24098 20.3562 3.87412 20.8996 4.6108C21.443 5.34748 21.8198 6.17327 22.0086 7.04102C22.1974 7.90878 22.1944 8.8015 21.9999 9.66823H23.3332C24.5709 9.66823 25.7579 10.1599 26.633 11.0351C27.5082 11.9102 27.9999 13.0972 27.9999 14.3349C27.9999 15.5726 27.5082 16.7596 26.633 17.6347C25.7579 18.5099 24.5709 19.0016 23.3332 19.0016H21.9999"
                                                        stroke="#021832"
                                                        stroke-width="2"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                    <path
                                                        d="M9.99988 15L13.9999 11L17.9999 15"
                                                        stroke="#021832"
                                                        stroke-width="2"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                    <path
                                                        d="M13.9999 11V23"
                                                        stroke="#021832"
                                                        stroke-width="2"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                </svg>
                                                <label class="form-control text-center" id="file-label" for="imageUpload">{{
                                                    $t('survey.upload_image')
                                                }}</label>
                                                <input
                                                    type="file"
                                                    id="imageUpload"
                                                    ref="fileInput"
                                                    @change="handleImageUpload"
                                                    class="form-control d-none"
                                                />
                                                <div v-if="image" class="mt-3">
                                                    <img :src="image" alt="image" class="img-thumbnail" width="300" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="survey-save-container" class="fixed-right bg-transparent pb-6 pe-6">
            <button
                @click="handleSave"
                class="btn-dark d-flex dontainer justify-content-center save_question_form my-auto mb-3 mt-3 rounded-12 fw-semibold height_btn_page px-4 fs-6"
                style="padding-top: 19px"
            >
                {{ $t('common.save') }}
            </button>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

import SurveyQuestion from './SurveyQuestion.vue'

export default {
    name: 'SurveyForm',
    // 'prestations', 'tagcategories',
    props: ['questionsprops', 'name', 'slug', 'categories', 'image', 'profaqs', 'descriptionprops', 'isV3', 'boundsEnabled'],
    data: () => ({
        test: 0,
        questions: [],
        faqs: [],
        description: null,
        buttonReqAiText: '',
        buttonSendText: '',
        isLoading: false,
        promptFaq: '',
        showAiPrompt: false,
    }),
    created() {
        this.buttonReqAiText = this.$t('survey.ai_help')
        this.buttonSendText = this.$t('common.send')
    },
    mounted() {
        this.questionsLength = this.questions.length
        this.componentKey = this.questionsLength
        this.questions = Object.values(this.questionsprops)
        this.description = this.descriptionprops
        this.faqs = this.profaqs
    },
    methods: {
        handleSave(e) {
            if (this.isV3) {
                e.preventDefault()
                this.$emit('save')
            }
        },
        addQuestion() {
            const empty_question = {
                answers_possibilities: [],
                prestations: [],
                created_at: new Date(),
                id: this.questions.length,
                is_in_customer_card: false,
                question: '',
                is_disabled: 0,
                is_required: 0,
                survey_id: 1,
                type: '1',
                is_deleted: 1,
                order: this.questions.length,
                updated_at: new Date(),
                numberQuestion_valid: -1,
                min_value: null,
                max_value: null,
                image: this.image,
            }
            this.questions.push(empty_question)
            this.$forceUpdate()
        },
        upHandler(index) {
            if (index >= 1) {
                const a = this.questions[index]
                const b = this.questions[index - 1]
                this.questions[index] = b
                this.questions[index - 1] = a
                this.$forceUpdate()
            }
        },
        lowHandler(index) {
            if (index < this.questions.length - 1) {
                const a = this.questions[index]
                const b = this.questions[index + 1]
                this.questions[index] = b
                this.questions[index + 1] = a
                this.$forceUpdate()
            }
        },
        deleteHandler(index) {
            this.questions.splice(
                this.questions.findIndex((element) => element.id === index),
                1
            )
            this.$forceUpdate()
        },

        triggerFileUpload() {
            this.$refs.fileInput.click()
        },

        handleImageUpload(event) {
            const file = event.target.files[0]
            if (file) {
                const reader = new FileReader()
                reader.onload = (e) => {
                    this.image = e.target.result
                }
                reader.readAsDataURL(file)
            }
        },

        addFAQ(question = '', answer = '') {
            this.faqs.push({ question: question, answer: answer })
        },

        removeFAQ(index) {
            this.faqs.splice(index, 1)
        },

        moveUp(index) {
            console.log('moveUp', index)
            if (index > 0) {
                const temp = this.faqs[index]
                this.faqs[index] = this.faqs[index - 1]
                this.faqs[index - 1] = temp
            }
        },

        moveDown(index) {
            if (index < this.faqs.length - 1) {
                const temp = this.faqs[index]
                this.faqs[index] = this.faqs[index + 1]
                this.faqs[index + 1] = temp
            }
        },

        async handleButtonClick() {
            this.isLoading = true
            this.buttonReqAiText = 'Chargement des données...'
            this.buttonSendText = 'Chargement des données...'

            try {
                const response = await axios.post(`/chat-research-faq`, {
                    type: 'website_faq',
                    text: this.promptFaq,
                    number: 7,
                })
                response?.data?.data?.data?.faq.forEach((item) => {
                    this.addFAQ(item.question, item.answer)
                })
            } catch (error) {
                this.$toast.error(error.response.data.message)
            } finally {
                this.isLoading = false
                this.hideTooltip()
                this.buttonReqAiText = this.$t('survey.ai_help')
                this.buttonSendText = this.$t('common.send')
            }
        },

        showTooltip() {
            this.showAiPrompt = true
        },

        hideTooltip() {
            this.showAiPrompt = false
        },
    },
}
</script>

<style scoped>
#survey-save-container {
    /* margin-left: 240px; */
    box-shadow:
        0 3px -6px rgba(0, 0, 0, 0.16),
        0 3px -6px rgba(0, 0, 0, 0.23);
}

.save_question_form {
    line-height: 1;
    font-size: 20px;
}

.save_question_form i {
    margin-right: 5px;
}

@media screen and (max-width: 991px) {
    #survey-save-container {
        margin-left: 0px;
    }
}
</style>
